import { Base2Presenter } from "core/presenter";

export default class EntitySelector extends Base2Presenter {
  initialState() {
    return {
      listVisible: false,
      entityList: [],
      filter: "",
      loading: true
    };
  }

  onChangeProps() {
    if (this.props.open || this.viewModel.listVisible) {
      this.reloadFilter();
    }
  }

  async reloadFilter() {
    this.enqueue({ loading: true });

    if(this.props.searchOptions) {
      const { repository, order, pagination, filter } = this.props.searchOptions;
    const filters = await filter(this.viewModel.filter);
    const params = { order, pagination, filters };
    const result = await repository.getListOnline(params);

    if (result.success) {
      let entityList = result.data;
      if (this.props.dummyItem) {
        entityList.unshift(this.props.dummyItem);
      }
      this.enqueue({
        entityList,
        loading: false
      });
    } else {
      this.enqueue({
        entityList: [],
        loading: false
      });
    }
    } else {
      this.enqueue({
        entityList:  this.props.fixedOptions,
        loading: false
      });
    }
  }

  onEdit() {
    this.enqueue({ listVisible: true });
    this.reloadFilter();
  }

  onListClose() {
    this.enqueue({ listVisible: false });
    if (this.props.onClose) {
      this.props.onClose();
    }
  }

  onClear() {
    this.props.onSelect(this.props.nullSelection);
  }

  onSelect(entity) {
    this.props.onSelect(entity);
    this.enqueue({ listVisible: false });
    if (this.props.onClose) {
      this.props.onClose();
    }
  }

  async onUpdateFilter(filter) {
    await this.enqueue({ filter: filter });
    const timer = setInterval(async () => {
      if (filter === this.viewModel.filter) {
        clearInterval(timer);
        await this.reloadFilter();
      }
    }, 1100);
  }
}



// WEBPACK FOOTER //
// ./src/components/support/entity-selector/presenter.js